(function () {
  var MOBILE_BREAKPOINT = 767.98;
  var SEARCH_PAGE_PATH = '/search';

  function isMobile() {
    var candidates = [window.innerWidth, window.outerWidth];
    if (document.documentElement && document.documentElement.clientWidth) {
      candidates.push(document.documentElement.clientWidth);
    }
    if (window.visualViewport && window.visualViewport.width) {
      candidates.push(window.visualViewport.width);
    }

    var viewportWidth = Math.min.apply(
      null,
      candidates.filter(function (value) {
        return typeof value === 'number' && value > 0;
      })
    );

    return viewportWidth <= MOBILE_BREAKPOINT;
  }

  function getSearchForm() {
    return document.querySelector('#search-form');
  }

  function getPopupSearch() {
    return document.querySelector('.header_search .popup-search');
  }

  function getActiveSearchRoot() {
    var openForm = document.querySelector('#search-form.open');
    if (openForm) return openForm;
    var form = getSearchForm();
    if (form && form.classList.contains('open')) return form;
    var popup = getPopupSearch();
    if (popup && popup.classList.contains('popup-search-show')) {
      return popup.closest('.header_search') || popup;
    }
    return form || document.querySelector('.header_search .search-full') || null;
  }

  function isSearchOpen() {
    var form = getSearchForm();
    var popup = getPopupSearch();
    return Boolean(
      (form && form.classList.contains('open')) ||
      (popup && popup.classList.contains('popup-search-show'))
    );
  }

  function isOnSearchPage() {
    return window.location.pathname === SEARCH_PAGE_PATH;
  }

  function getQueryForRedirect() {
    var input = document.querySelector('input[name="q"]');
    if (!input || typeof input.value !== 'string') return '';
    return input.value.trim();
  }

  function getSearchUrl(query) {
    if (!query) return SEARCH_PAGE_PATH;
    return SEARCH_PAGE_PATH + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last&type=product';
  }

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getSearchPageForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action="/search"]'));
    if (!forms.length) return null;

    var mainForm = forms.find(function (form) {
      return !!form.closest('#MainContent');
    });
    if (mainForm) return mainForm;

    var visibleForm = forms.find(function (form) {
      return isElementVisible(form);
    });

    return visibleForm || forms[0];
  }

  function redirectToMobileSearchPage(event) {
    if (!isMobile()) return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    if (isOnSearchPage()) {
      var activeForm = getSearchPageForm();
      var pageInput = activeForm
        ? activeForm.querySelector('input[name="q"], input[type="search"], .ssearch__input')
        : document.querySelector('#MainContent input[name="q"], #MainContent .ssearch__input');
      if (pageInput) {
        pageInput.focus();
      }
      return true;
    }

    window.location.href = getSearchUrl(getQueryForRedirect());
    return true;
  }

  function syncSearchIds() {
    if (!isMobile()) return;
    var activeRoot = getActiveSearchRoot();
    if (!activeRoot) return;

    [['#predictive-search', 'predictive-search'], ['#search_mini_form', 'search_mini_form']].forEach(function (pair) {
      var selector = pair[0];
      var canonicalId = pair[1];
      document.querySelectorAll(selector).forEach(function (node) {
        if (activeRoot.contains(node)) {
          node.id = canonicalId;
        } else if (node.id === canonicalId) {
          node.removeAttribute('id');
        }
      });
    });
  }

  function focusSearchInput() {
    if (!isMobile()) return;
    if (!isSearchOpen()) return;
    var activeRoot = getActiveSearchRoot();
    if (!activeRoot) return;
    var input = activeRoot.querySelector('.mobile-search-input, input[type="search"]');
    if (!input) return;

    window.setTimeout(function () {
      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
      if (typeof input.setSelectionRange === 'function') {
        var val = input.value || '';
        input.setSelectionRange(val.length, val.length);
      }
    }, 120);
  }

  function lockBodyScroll(locked) {
    var html = document.documentElement;
    if (!html) return;
    if (locked) {
      html.classList.add('mobile-search-lock');
    } else {
      html.classList.remove('mobile-search-lock');
    }
  }

  var detachedPlaceholder = null;

  function moveSearchFormToBody() {
    var form = getSearchForm();
    if (!form || form.dataset.mobileDetached === 'true') return;

    detachedPlaceholder = document.createElement('span');
    detachedPlaceholder.setAttribute('data-mobile-search-placeholder', 'true');
    detachedPlaceholder.style.display = 'none';
    form.parentNode.insertBefore(detachedPlaceholder, form);
    document.body.appendChild(form);
    form.dataset.mobileDetached = 'true';
  }

  function restoreSearchFormPosition() {
    var form = getSearchForm();
    if (!form || form.dataset.mobileDetached !== 'true' || !detachedPlaceholder) return;

    detachedPlaceholder.parentNode.insertBefore(form, detachedPlaceholder);
    detachedPlaceholder.remove();
    detachedPlaceholder = null;
    delete form.dataset.mobileDetached;
  }

  function clearSelectedPredictiveItems() {
    document.querySelectorAll('[data-predictive-search] li[aria-selected="true"]').forEach(function (li) {
      li.setAttribute('aria-selected', 'false');
    });
  }

  function closeSearch() {
    var form = getSearchForm();
    if (form && form.classList.contains('open')) {
      var closeBtn = form.querySelector('.btn-search-close');
      if (closeBtn) {
        closeBtn.click();
        return;
      }
      form.classList.remove('open');
    }

    var popup = getPopupSearch();
    if (popup && popup.classList.contains('popup-search-show')) {
      popup.classList.remove('popup-search-show');
      document.documentElement.classList.remove('open-drawer', 'open-search');
      document.body.style.removeProperty('padding-right');
    }
  }

  function applySearchState() {
    if (!isMobile()) {
      lockBodyScroll(false);
      restoreSearchFormPosition();
      return;
    }

    // HOTFIX: Mobile Fullscreen-/Detach-Logik deaktiviert,
    // damit kein blockierender Dark-Layer mehr die Seite sperrt.
    lockBodyScroll(false);
    restoreSearchFormPosition();

    var open = isSearchOpen();

    var form = getSearchForm();
    if (form) {
      form.classList.toggle('mobile-search-open', open);
    }

    if (open) {
      syncSearchIds();
      focusSearchInput();
    } else {
      clearSelectedPredictiveItems();
    }
  }

  function bindSearchToggleHandlers() {
    document.querySelectorAll('.top-search-toggle').forEach(function (toggle) {
      if (toggle.dataset.mobileSearchFixBound === 'true') return;
      toggle.dataset.mobileSearchFixBound = 'true';
      toggle.addEventListener('click', function (event) {
        if (redirectToMobileSearchPage(event)) {
          return;
        }
        window.setTimeout(applySearchState, 160);
      }, true);
    });

    document.querySelectorAll('.btn-search-close').forEach(function (closeBtn) {
      if (closeBtn.dataset.mobileSearchFixBound === 'true') return;
      closeBtn.dataset.mobileSearchFixBound = 'true';
      closeBtn.addEventListener('click', function () {
        window.setTimeout(applySearchState, 60);
      });
    });
  }

  function bindEscapeHandler() {
    if (document.body.dataset.mobileSearchEscBound === 'true') return;
    document.body.dataset.mobileSearchEscBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!isMobile()) return;
      if (!isSearchOpen()) return;
      event.preventDefault();
      closeSearch();
      applySearchState();
    });
  }

  function bindGlobalMobileRedirect() {
    if (document.body.dataset.mobileSearchRedirectBound === 'true') return;
    document.body.dataset.mobileSearchRedirectBound = 'true';

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var toggle = target.closest('.top-search-toggle');
      if (!toggle) return;
      redirectToMobileSearchPage(event);
    }, true);
  }

  function initMobileSearchPage() {
    if (!isMobile() || !isOnSearchPage()) {
      document.querySelectorAll('.mobile-search-page-back').forEach(function (node) {
        if (!node.classList.contains('mobile-search-page-back-native')) {
          node.remove();
        }
      });
      return;
    }

    var inputSelector = '#MainContent form[action="/search"] input[name="q"], #MainContent .ssearch__input';
    [120, 450, 900, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (document.activeElement && document.activeElement !== document.body) return;
        var input = document.querySelector(inputSelector);
        if (!input) return;
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          input.focus();
        }
      }, delay);
    });

    // Alte, per JS injizierte Back-Buttons aus früheren Fixes aufräumen.
    document.querySelectorAll('.mobile-search-page-back').forEach(function (node) {
      if (!node.classList.contains('mobile-search-page-back-native')) {
        node.remove();
      }
    });
  }

  function runInitPass() {
    bindSearchToggleHandlers();
    bindEscapeHandler();
    bindGlobalMobileRedirect();
    applySearchState();
    initMobileSearchPage();
  }

  function scheduleInitPasses() {
    [0, 120, 500, 1000, 2000, 3200].forEach(function (delay) {
      window.setTimeout(runInitPass, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitPasses);
  } else {
    scheduleInitPasses();
  }

  if (window.MutationObserver) {
    var observerTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(observerTimer);
      observerTimer = setTimeout(runInitPass, 120);
    });

    function observeBody() {
      if (!document.body) return;
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (document.body) {
      observeBody();
    } else {
      document.addEventListener('DOMContentLoaded', observeBody);
    }
  }

  window.addEventListener('resize', function () {
    runInitPass();
  });
})();
